import { gql } from '@apollo/client/core';

const NotificationCommentPreviewFragment = gql`
  fragment CommentPreview on Comment {
    id
    text
    deletedAt
    author {
      __typename
      ... on Anonymous {
        username
        warRoomAvatarUrl
      }

      ... on Public {
        slug
        firstname
        lastname
        avatarUrl
      }
    }
    post {
      slug
    }
  }
`;

export default NotificationCommentPreviewFragment;
